import React, { useEffect } from 'react';
import { Box, Alert, Typography, Paper } from '@mui/material';
import ContractorManagementWidget from '../components/ContractorManagementWidget';

// Contractor Management Page - Administrator Portal
const Contractors: React.FC = () => {
  useEffect(() => {
    console.log('✅✅✅ Contractors page component MOUNTED');
    console.log('✅✅✅ Rendering ContractorManagementWidget...');
  }, []);

  return (
    <Box sx={{ width: '100%', p: 0 }}>
      <Paper sx={{ p: 2, mb: 2, bgcolor: '#e8f5e9' }}>
        <Alert severity="success">
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            ✅ Contractor Management Page Loaded Successfully
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            All contractor management functions are available in the tabs below.
          </Typography>
        </Alert>
      </Paper>
      <ContractorManagementWidget />
    </Box>
  );
};

export default Contractors;
